export default __webpack_public_path__ + "static/media/privacy_policy.d0a9882b.pdf";